import React from "react";
import siteConfig from "../config/siteConfig";
import { PolicyLayout, PolicyNotice, PolicySection } from "./Terms";
import "../css/terms.scss";

const sections = [
  { id: "overview", label: "Cookie overview" },
  { id: "essential", label: "Essential storage" },
  { id: "choices", label: "Your choices" },
  { id: "updates", label: "Updates and contact" },
];

function Cookies() {
  return (
    <PolicyLayout eyebrow="Legal · Cookies" intro={`How ${siteConfig.brandName} uses browser storage and how you can control it.`} modifier="cookies" sections={sections} title="Cookie policy">
      <PolicyNotice tone="success" title="Essential storage only"><p>This storefront does not use advertising or social-media tracking cookies.</p></PolicyNotice>
      <PolicySection id="overview" title="1. Cookie overview"><p>Cookies and local storage are small records saved by your browser. They support site functions and remember choices on the same device.</p></PolicySection>
      <PolicySection id="essential" title="2. Essential storage"><p>We use browser storage to keep cart and wishlist selections and, where necessary, maintain checkout continuity. These functions are needed for the shopping experience.</p><p>We do not use this storage to build advertising profiles or follow you across unrelated websites.</p></PolicySection>
      <PolicySection id="choices" title="3. Your choices"><p>You can clear site data or block storage in your browser settings. Blocking essential storage may prevent the cart, wishlist, or checkout from working correctly.</p></PolicySection>
      <PolicySection id="updates" title="4. Updates and contact"><p>We will update this policy before adding non-essential analytics, advertising, or third-party tracking. Questions may be sent to <a href={`mailto:${siteConfig.contact.email}`}>{siteConfig.contact.email}</a>.</p></PolicySection>
    </PolicyLayout>
  );
}

export default Cookies;
